module.exports = __webpack_public_path__ + "static_pc/img/gj04.6cb65bf7.jpg";